import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ children, onClose, isOpen, widthClass = 'max-w-md' }) => {
    useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    const modalRoot = document.getElementById('modal-root');

    return ReactDOM.createPortal(
        <div data-testid="modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[5000]">
            <div className={`bg-white rounded-lg p-8 w-full mx-4 ${widthClass}`}>
                <div className="flex justify-end">
                    <button onClick={onClose} data-testid="modal-close" className="text-gray-500 hover:text-gray-700">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </div>
                {children}
            </div>
        </div>,
        modalRoot
    );
};

export default Modal;
